import React from 'react'

import 'core-js/proposals/string-match-all'
import { createRoot } from 'react-dom/client'

import './index.css'
import reportWebVitals from './reportWebVitals'

import { GTMInitialize } from './components/app/GoogleTagManager'
import { AppIndex } from './AppIndex'

GTMInitialize()

const container = document.getElementById('root')
const root = createRoot(container!)
root.render(<AppIndex />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
